import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export const ModalRemovePeca = ({ peca, onCancel, onConfirm, removing }) => (
  <Modal show={!!peca} onHide={removing ? undefined : onCancel} centered>
    <Modal.Header closeButton={!removing}>
      <Modal.Title>Remover peça do vagão</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Deseja remover a peça <strong>{peca?.ordem_Serial}</strong> deste vagão? A
      alteração será gravada imediatamente, sem precisar confirmar o vagão todo.
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel} disabled={removing}>
        Não
      </Button>
      <Button variant="danger" onClick={onConfirm} disabled={removing}>
        {removing ? "Removendo..." : "Sim, remover"}
      </Button>
    </Modal.Footer>
  </Modal>
);
